/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Tasks_Panel_CloseInputs */

const en_tasks_panel_close = /** @type {(inputs: Tasks_Panel_CloseInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Close panel`)
};

const fr_tasks_panel_close = /** @type {(inputs: Tasks_Panel_CloseInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fermer le panneau`)
};

const ms_sg2_tasks_panel_close = /** @type {(inputs: Tasks_Panel_CloseInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tutup panel`)
};

/**
* | output |
* | --- |
* | "Close panel" |
*
* @param {Tasks_Panel_CloseInputs} inputs
* @param {{ locale?: "en" | "fr" | "ms-SG" }} options
* @returns {LocalizedString}
*/
export const tasks_panel_close = /** @type {((inputs?: Tasks_Panel_CloseInputs, options?: { locale?: "en" | "fr" | "ms-SG" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Tasks_Panel_CloseInputs, { locale?: "en" | "fr" | "ms-SG" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_tasks_panel_close(inputs)
	if (locale === "fr") return fr_tasks_panel_close(inputs)
	return ms_sg2_tasks_panel_close(inputs)
});